import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="bg-gradient-to-r from-sky-600 to-cyan-500 text-white shadow-lg">
      <div className="container mx-auto px-4 py-6 text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight">
        রসায়ন
        </h1>
        <p className="mt-2 text-base sm:text-lg text-cyan-100">
          Shihab
        </p>
      </div>
    </header>
  );
};

export default Header;
